import { useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import Editor from "../../../../../../utils/common/Editor";

import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import SyncIcon from "@mui/icons-material/Sync";

import EmailGenerateItems from "./EmailGenerateItems";

const initialGenerateValue = [
  "<p>Hi Cheyenne,</p><p>Check a few things to avoid issues with pairing:</p><p>1. Please check your Wi-Fi settings before pairing up and make sure that you are connected to a 2.4GHz Wi-Fi network.</p><p>2. Make sure that you've entered your correct Wi-Fi password.</p><p>3. While connecting/adding your camera, it's suggested to place the camera near your Wi-Fi router. Once you move your camera near the Wi-Fi router, there should be no obstructions or any objects that may block the signal from the router to your camera.</p>",
];

const EmailGenerate = ({ handleOpenAI, handleInsertReply }: any) => {
  const [generateReplies, setGenerateReplies] = useState(initialGenerateValue);

  const handleGenerateReply = () => {
    if (generateReplies?.length < 2) {
      const newReply =
        "<p><span style='font-size: 14px;'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla mattis venenatis placerat. Fusce vestibulum efficitur nisi vel vulputate. Aliquam blandit augue sit amet tempus commodo. Donec dictum interdum ante ut ultricies. Maecenas sit amet imperdiet nibh, at fermentum metus. Etiam eleifend finibus dolor, a varius lorem maximus eu. Morbi ut pharetra dui. Praesent erat velit, mollis bibendum nibh quis, dapibus pulvinar felis. Sed sit amet purus non turpis posuere eleifend. Pellentesque pulvinar odio non auctor lacinia. Phasellus sed lacinia elit, placerat convallis enim. Nam sit amet pulvinar turpis. Aliquam posuere odio ut quam bibendum, sed sollicitudin justo ornare.</span></p>";

      setGenerateReplies((prevState) => [...prevState, newReply]);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      flexBasis="35%"
      sx={{
        border: "1px solid rgba(60, 64, 67, 0.2)",
        borderRadius: "8px",
        padding: "8px",
      }}
    >
      <Box display="flex">
        <Box
          sx={{
            display: "flex",
            borderRadius: "8px",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(40, 88, 211, 0.3)",
            color: "#2858D3",
            padding: "5px 10px",
            cursor: "pointer",
            width: "30px",
            height: "30px",
          }}
          onClick={handleOpenAI}
        >
          AI
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" mt="10px">
        <Box
          sx={{
            maxHeight: "425px",
            overflow: "scroll",
            overflowX: "hidden",
            "::-webkit-scrollbar": {
              width: 0,
              background: "transparent",
            },
          }}
        >
          {generateReplies.map((reply) => {
            return (
              <EmailGenerateItems
                content={reply}
                handleInsertReply={handleInsertReply}
              />
            );
          })}
        </Box>
        <Box display="flex" mt="9px">
          <Button
            variant="outlined"
            startIcon={<SyncIcon />}
            sx={{
              background: "#FFF!important",
            }}
            onClick={handleGenerateReply}
          >
            REGENERATE
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default EmailGenerate;
